import * as types from '../mutation-types'
import Http from 'utils/http'

export const get = ({ dispatch }, site, include = []) => {
	return Http.get(`sites/${site}/simulators`).then(response => {
		dispatch(types.SET_SIMULATOR_SETUP, response.body.data);
	});
}

export const update = ({ dispatch }, site, simulator, data) => {
	return Http.put(`sites/${site}/simulators/${simulator}`, {data});
}



// WEBPACK FOOTER //
// ./src/vuex/actions/simulator-setup.js